/**
 * api接口的统一出口
 */
let api = {}
// 获取全部api文件
const apiFiles = require.context(
  // 其api目录的相对路径
  './modules',
  // 是否查询其子目录
  false,
  // 匹配基础组件文件名的正则表达式
  /[\w-]+\.js$/
)

apiFiles.keys().forEach(fileName => {
  // 获取组件配置
  const apis = apiFiles(fileName)
  // 剥去文件名开头的 `./` 和结尾的扩展名
  const apiName = fileName.replace(/^\.\/(.*)\.\w+$/, '$1')
  if (apiName == 'index') return

  Object.keys(apis).forEach(item => {
    api[item] = apis[item]
  })
})
export default api



// WEBPACK FOOTER //
// ./src/api/index.js